import React, { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';

export default function CookieBanner() {
  const [showBanner, setShowBanner] = useState(false);

  useEffect(() => {
    // Verificar si ya aceptó las cookies
    const cookiesAccepted = localStorage.getItem('cookiesAccepted');
    if (!cookiesAccepted) {
      setShowBanner(true);
    }
  }, []);

  const handleAccept = () => {
    localStorage.setItem('cookiesAccepted', 'true');
    setShowBanner(false);
  };

  const handleReject = () => {
    localStorage.setItem('cookiesAccepted', 'false');
    setShowBanner(false);
  };

  if (!showBanner) return null;

  return (
    <div className="fixed bottom-0 left-0 right-0 bg-gray-900 text-white p-4 md:p-6 shadow-2xl z-50 animate-slide-up">
      <div className="max-w-7xl mx-auto flex flex-col md:flex-row items-center justify-between gap-4">
        <div className="flex-1 text-sm md:text-base">
          <p className="mb-2">
            <strong>Uso de Cookies</strong>
          </p>
          <p className="text-gray-300">
            Utilizamos cookies esenciales para el funcionamiento de la aplicación (autenticación y sesión). 
            No utilizamos cookies de terceros ni con fines publicitarios. 
            Al continuar usando este sitio, aceptas nuestra{' '}
            <Link to="/politica-privacidad" className="text-blue-400 hover:text-blue-300 underline">
              Política de Privacidad
            </Link>.
          </p>
        </div>
        <div className="flex gap-3 w-full md:w-auto">
          <button
            onClick={handleReject}
            className="flex-1 md:flex-initial bg-gray-700 hover:bg-gray-600 text-white px-6 py-2.5 rounded-lg transition font-medium"
          >
            Rechazar
          </button>
          <button
            onClick={handleAccept}
            className="flex-1 md:flex-initial bg-blue-600 hover:bg-blue-500 text-white px-6 py-2.5 rounded-lg transition font-medium"
          >
            Aceptar
          </button>
        </div>
      </div>
    </div>
  );
}
